import React from 'react'
import Box from '@mui/system/Box'
import { useCommonStyles } from '../common'
import AppLogo from './../../assets/logos/mainlogo.png'
import { useHistory } from 'react-router-dom'

const AppLogoComp = () => {
    const commonClasses =  useCommonStyles()
    const history = useHistory()

    const gotoHomePage = () => {
        history.push('/products')
    }

    return <Box className={commonClasses.logoWrapper}>
        <img
            src={AppLogo}
            onClick={gotoHomePage}
            className={commonClasses.appLogo}
            alt="App Logo"
        />
    </Box>
} 

export default AppLogoComp;
